import { render } from "./ShopComponent.vue?vue&type=template&id=10fc1c44"
import script from "./ShopComponent.vue?vue&type=script&lang=js"
export * from "./ShopComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__